import { useSelector } from 'react-redux';
import { IEnquiryFormModal } from '@bridebook/web/components/enquiries/enquiry-form-modal/index';
import { getShowEnquiryForm } from '@bridebook/web/lib/enquiries/selectors';
import { lazyComponent } from '@bridebook/web/lib/utils/lazy/lazy-component';
import { memo } from 'react';

const EnquiryFormModal = lazyComponent<IEnquiryFormModal>(
  () => import('@bridebook/web/components/enquiries/enquiry-form-modal'),
);

interface EnquiryFormModalLazyProps {}

const EnquiryFormModalLazy: React.FC<EnquiryFormModalLazyProps> = () => {
  const show = useSelector(getShowEnquiryForm);
  if (!show) return null;

  return <EnquiryFormModal showEnquiryForm={show} />;
};

export default memo(EnquiryFormModalLazy);
